import React from 'react';

import classNames from 'classnames';

import { figure, FOOTER_CELL } from './commitmentFormat';

const INDENT = ['', 'tw-ps-6', 'tw-ps-10'];

/**
 * The lines being committed, read-only. Depth-0 rows are what the order commits and
 * add up to the footer; deeper rows break a line down by item or venue and are
 * shown for reading only.
 */
export default function CommitmentDetailTable({ lines, total }) {
    return (
        <div>
            <div className="bc-eyebrow">{$t('Commitment')}</div>
            <div className="inbud-table_wrapper bc-table-wrapper">
                <table className="inbud-table bc-table">
                    <thead>
                        <tr>
                            <th>{$t('Budget line')}</th>
                            <th className="bc-num">{$t('Cash')}</th>
                            <th className="bc-num">{$t('VIK')}</th>
                            <th className="bc-num">{$t('Total')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lines.map((line, index) => (
                            <tr key={index}>
                                <td className={classNames(INDENT[Math.min(line.depth, 2)], { 'tw-font-medium': line.depth === 0 })}>
                                    {line.name}
                                    {line.path && <span className="bc-sub">{line.path}</span>}
                                </td>
                                <td className="bc-num">{figure(line.cash)}</td>
                                <td className="bc-num">{figure(line.vik)}</td>
                                <td className="bc-num">{figure(line.total)}</td>
                            </tr>
                        ))}
                        <tr className="tw-font-semibold">
                            <td className={FOOTER_CELL}>{$t('Total committing')}</td>
                            <td className={`bc-num ${FOOTER_CELL}`}>{figure(total.cash)}</td>
                            <td className={`bc-num ${FOOTER_CELL}`}>{figure(total.vik)}</td>
                            <td className={`bc-num ${FOOTER_CELL}`}>{figure(total.total)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}
